export class BaseConnection<T> {
    public from: string;
    public to: string;
    public id: number;
    public meta: T;
    
    constructor(
        from: string,
        to: string,
        id: number,
        meta: T,
    ) {
        this.from = from;
        this.to = to;
        this.id = id;
        this.meta = meta;
    }
}